const Help = () => <div>Help here</div>;

export default Help;
